import ReviewProductCardSkeleton from "./ReviewProductCardSkeleton";
import ReviewSellerInfoSkeleton from "./ReviewSellerInfoSkeleton";
import ReviewHeaderSkeleton from "./ReviewHeaderSkeleton";
import SearchAndSortSkeleton from "./SearchAndSortSkeleton";
import SizeRecommendationSkeleton from "./SizeRecommendationSkeleton";
import ReviewSummarySkeleton from "./ReviewSummarySkeleton";
import PhotoReviewsSkeleton from "./PhotoReviewsSkeleton";
import ReviewCardSkeleton from "./ReviewCardSkeleton";

const ProductReviewPageSkeleton = () => {
  return (
    <div className="py-6 container-xs md:py-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-5 space-y-4">
          <ReviewProductCardSkeleton />
          <ReviewSellerInfoSkeleton />
        </div>
        <div className="lg:col-span-7 space-y-6">
          <ReviewHeaderSkeleton />
          <SearchAndSortSkeleton />
          <SizeRecommendationSkeleton />
          <ReviewSummarySkeleton />
          <PhotoReviewsSkeleton />
          {Array.from({ length: 3 }).map((_, i) => (
            <ReviewCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductReviewPageSkeleton;
